<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 14:10:07
 * @LastEditors: lau
 * @LastEditTime: 2023-02-02 10:32:55
-->
<!-- 获取停车记录详情接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode":"2KNTYVWC",
                "parkingCode":"20160723162730110",
                "carCode":"湘OQKKZA",
                "cardCode": ""
            },
            responseCode: {
                "data": {
                    "billList": [{
                        "payValue": "1.00",
                        "disValue": "0.50",
                        "billCode": "123434eew2",
                        "payDate":"20170724225600",
                        "payOrigin": "2",
                        "payOriginRemark": "remark1",
                        "paymentMode": "2",
                        "paymentModeRemark": "remark2"
                    }], "carCode": "湘OQKKZA", "cardCode": "", "enterDate": "20170724010000", "enterImageArray": { "carImage": "http://221.4.168.157:13388/openydt/files/images/2017072401000070302888-body-in-nor.jpg?s=7d94648c", "plateImage": "http://221.4.168.157:13388/openydt/files/images/2017072401000070302888-plate-in-nor.jpg?s=10170a41" }, "enterOperateTime": "20170724010000", "enterOperator": "System", "enterType": 1, "enterVipType": 0, "outAddress": "AKE出口", "outDate": "20170724225611", "outImageArray": { "carImage": "http://221.4.168.157:13388/openydt/files/images/2017072401000070302888-body-out-nor.jpg?s=27c04c9a", "plateImage": "http://221.4.168.157:13388/openydt/files/images/2017072401000070302888-plate-out-nor.jpg?s=0d60c3d2" }, "outOperateTime": "20170724225611", "outOperator": "lgc岗亭", "outType": 2, "outVipType": 0, "parkingCode": "2017072401000070302888", "totalFavorFee": 0.00, "totalParkFee": 10.00, "totalPayFee": 10.00
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取停车场某条停车记录详情",
                t_url: this.commonUrls.test+"getParkDetailIgnoreStatus",
                p_url: this.commonUrls.prod+"getParkDetailIgnoreStatus",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkingCode', info2: 'parkingCode跟carCode和cardCode三选一', info3: 'String', info4: '停车流水号' },
                        { info1: 'carCode', info2: 'parkingCode跟carCode和cardCode三选一', info3: 'String', info4: '车牌（获取最近一次正常的停车记录）' },
                        { info1: 'cardCode', info2: 'parkingCode跟carCode和cardCode三选一', info3: 'String', info4: '卡号（获取最近一次正常的停车记录）' },
                        { info1: 'isCallReliefDetail', info2: '否', info3: 'Integer', info4: '是否带出优惠信息(0否,1是),默认不带出' },

                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'cardCode', info2: '是', info3: 'String', info4: '停车卡编号' },
                        { info1: 'enterDate', info2: '是', info3: 'String', info4: '入场时间，yyyyMMddHHmmss' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号，v1.19以后支持' },
                        { info1: 'enterImageArray', info2: '是', info3: 'JSONObject', info4: '入场图片列表[{"plateImage":"车牌图片直接访问url","carImage"："车身图片直接访问url"}]' },
                        { info1: 'enterType', info2: '是', info3: 'Integer', info4: '入场放行类型，0未确认，1自动放行，2确认放行，3异常放行，4遥控开闸' },
                        { info1: 'enterVipType', info2: '是', info3: 'Integer', info4: '入场VIP类型，0未定义，1普通，2本地VIP，3外部VIP，4黑名单，5访客，6预定，7共享，8红名单' },
                        { info1: 'enterOperator', info2: '是', info3: 'String', info4: '入场放行操作员' },
                        { info1: 'enterOperateTime', info2: '是', info3: 'String', info4: '入场放行时间，yyyyMMddHHmmss' },
                        { info1: 'outDate', info2: '是', info3: 'String', info4: '出场时间，yyyyMMddHHmmss' },
                        { info1: 'outImageArray', info2: '是', info3: 'JSONObject', info4: '出场图片列表[{"plateImage":"车牌图片直接访问url","carImage"："车身图片直接访问url"}]' },
                        { info1: 'outAddress', info2: '是', info3: 'String', info4: '出场通道名' },
                        { info1: 'outType', info2: '是', info3: 'Integer', info4: '出场放行类型，0未确认，1自动放行，2确认放行，3异常放行' },
                        { info1: 'outVipType', info2: '是', info3: 'Integer', info4: '出场VIP类型，0未定义，1普通，2本地VIP，3外部VIP，4黑名单，5访客' },
                        { info1: 'outOperator', info2: '是', info3: 'String', info4: '出场放行操作员' },
                        { info1: 'outOperateTime', info2: '是', info3: 'String', info4: '出场放行时间，yyyyMMddHHmmss' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车流水号' },
                        { info1: 'totalParkFee', info2: '是', info3: 'Decimal', info4: '总停车费用' },
                        { info1: 'totalFavorFee', info2: '是', info3: 'Decimal', info4: '总优惠费用' },
                        { info1: 'totalPayFee', info2: '是', info3: 'Decimal', info4: '总支付费用' },
                        { info1: 'billList', info2: '是', info3: 'JSONArray', info4: '支付账单信息列表' },
                        { info1: 'parkReliefValue', info2: '否', info3: 'Decimal', info4: '线下优惠金额' },
                        { info1: 'platformReliefValue', info2: '否', info3: 'Decimal', info4: '平台优惠金额' },
                        { info1: 'actChargeValue', info2: '否', info3: 'Decimal', info4: '线上实际已缴费总金额' },
                        { info1: 'actCrashValue', info2: '否', info3: 'Decimal', info4: '线下缴费总金额' },
                        { info1: 'enterCustomVipName', info2: '否', info3: 'String', info4: '进场用户自定义VIP名称' },
                        { info1: 'parkingDataStatus', info2: '否', info3: 'Integer', info4: '数据状态 (0异常 ，1正常)' },

                        ]
                },{
                    titleName: 'billList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'payValue', info2: '是', info3: 'Decimal', info4: '支付金额' },
                        { info1: 'disValue', info2: '否', info3: 'Decimal', info4: '优惠金额' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '第三方系统缴费订单号' },
                        { info1: 'payDate', info2: '是', info3: 'String', info4: '支付时间，yyyyMMddHHmmss' },
                        { info1: 'payOrigin', info2: '是', info3: 'int', info4: '支付来源，<url>参考附录:/Api/appendixData#appendixData_1</url>' },
                        { info1: 'payOriginRemark', info2: '是', info3: 'String', info4: '支付来源备注' },
                        { info1: 'paymentMode', info2: '是', info3: 'String', info4: '支付方式，<url>参考附录:/Api/appendixData#appendixData_0</url>' },
                        { info1: 'paymentModeRemark', info2: '是', info3: 'String', info4: '支付方式备注' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/getParkDetailIgnoreStatus.vue